module.exports = __webpack_public_path__ + "static/img/yewei.b63eaf01.png";